module.exports = __webpack_public_path__ + "img/banner_left.2316b2ff.png";